import Hero from "../components/home/Hero";
import Features from "../components/home/Features";
import Products from "../components/home/Products";
import NewsPreview from "../components/home/NewsPreview";

export default function HomePage() {
  return (
    <>
      <Hero />
      <Features />
      <Products />
      <NewsPreview />
    </>
  );
}
